import jwtDecode, { JwtPayload } from 'jwt-decode'

export default class TokenStorage {
  private static readonly ACCESS_TOKEN = 'application_id_token'

  private static parseToken(token: string | null): string | null {
    if (token) {
      return JSON.parse(token)
    }

    return token
  }

  public static getAccessToken(): string | null {
    return TokenStorage.parseToken(localStorage.getItem(TokenStorage.ACCESS_TOKEN))
  }

  public static unsetToken(): void {
    localStorage.removeItem(TokenStorage.ACCESS_TOKEN)
  }

  public static storeAccessToken(accessToken: string): void {
    localStorage.setItem(TokenStorage.ACCESS_TOKEN, JSON.stringify(accessToken))
  }

  public static getDecodedAccessToken(accessToken: string | null): JwtPayload | null {
    return accessToken ? jwtDecode<JwtPayload>(accessToken) : null
  }

  public static getAccessTokenExpirationDate(decoded: JwtPayload | null): Date | null {
    if (!decoded || !('exp' in decoded) || typeof decoded.exp === 'undefined') {
      return null
    }
    const d = new Date(0)
    d.setUTCSeconds(decoded.exp)
    return d
  }

  public static isAccessTokenExpired(decoded: JwtPayload | null): boolean {
    const d = TokenStorage.getAccessTokenExpirationDate(decoded)
    if (d === null) {
      return false
    }
    return !(d.valueOf() > new Date().valueOf())
  }

  public static willAccessTokenExpireSoon(decoded: JwtPayload | null): boolean {
    const chkDate = TokenStorage.getAccessTokenExpirationDate(decoded)

    if (chkDate === null) {
      return true
    }

    const sysDate = new Date()

    chkDate.setSeconds(chkDate.getSeconds() - 600)

    return sysDate.valueOf() > chkDate.valueOf()
  }
}
